import React from "react";
import { Activities as ActivityModule } from "../../modules";
import useFrontStore from "../../FrontStore";
import { Container } from "@mui/joy";

const Activities = (props) => {
	const { eventDatas } = useFrontStore.useContainer();
	return (
		<Container maxWidth="md" sx={{ p: 0 }}>
			<ActivityModule {...eventDatas} />
		</Container>
	);
};

export default Activities;
